import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { POST_SELECTED_WHEN } from "../../store/action";
import { dayPlusOne, todayDate } from "../functions/dateFunctions";
import "../styles/layout.css";

// image importation

import { configureCrisp } from "../../utils/crispConfig";
import JoinFamilyAbout from "../elements/join-family";
import OurGoals_UserComments from "../elements/ourGoals_userComments";

const LayoutCareer = () => {
  let selectedWhen = useSelector((state) => state.selectedWhen);
  let selectedLang = useSelector((state) => state.lang);

  const dispatch = useDispatch();

  useEffect(() => {
    configureCrisp({
      autoload: true,
      lockMaximized: false,
      lockFullview: false
    });
    initialData();
  }, []);

  const initialData = async () => {
    if (!selectedWhen || selectedWhen <= todayDate()) {
      const tday = dayPlusOne();
      WhenDate(tday);
    }
  };

  const WhenDate = (value) => dispatch(post_selected_when(value));

  return (
    <div className="global-block">
      <div className="full-block">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            marginTop: "30px"
          }}
        >
          <div style={{ maxWidth: "2800px" }}>
            {" "}
            <JoinFamilyAbout />
            <OurGoals_UserComments />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LayoutCareer;

const post_selected_when = (data) => ({
  type: POST_SELECTED_WHEN,
  data: data
});


